import {StyleSheet} from "react-native";

export const styles = StyleSheet.create({
   button: {
       borderRadius: 20,
   },
    text: {
        color: "white",
        fontWeight: "900",
        fontFamily: "Montserrat"
    }
});